// Справочник ролей для ИП (Индивидуальный предприниматель)
export const ipRoles = [
  { code: "relative", value: "родственник" },
  { code: "friend", value: "друг" },
  { code: "mariage", value: "супруг/супруга" },
  { code: "other", value: "другое" }
];

// Справочник ролей для ТОО (Товарищество с ограниченной ответственностью)
export const tooRoles = [
  { code: "financial", value: "финансовый директор" },
  { code: "accountant", value: "главный бухгалтер/бухгалтер" },
  { code: "lawyer", value: "юрист" },
  { code: "manager", value: "офис менеджер/секретарь" },
  { code: "other", value: "другое" }
];

// Тип для роли контакта
export interface ContactRole {
  code: string;
  value: string;
}

// Тип для контакта третьего лица
export interface ThirdPartyContact {
  fio: string;
  mobile: string;
  role: ContactRole;
}

// Структура данных для контактов
export interface ContactsData {
  contacts: ThirdPartyContact[];
}
